import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useI18n} from "@/components/shop/I18nProvider";
import {getCampaignPage, type CampaignResponse} from "@corporatesclub/shared";

export function CampaniePage() {
  const {t} = useI18n();
  const [data, setData] = useState<CampaignResponse | null>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    getCampaignPage().then((r) => {
      if(r.mode === "redirect" && r.url) {
        window.location.href = r.url;
        return;
      }
      setData(r);
    }).catch((e: Error) => setErr(e.message));
  }, []);
  if(err) return <div className="textZone"><p className="notfound">{err}</p></div>;
  if(!data) return <div className="textZone"><p>{t("Loading products...")}</p></div>;
  if(data.mode === "html" && data.content) {
    return (
      <div className="textZone cmsPage">
        <h1 className="mainTitle wLine cmsPage"><span>{data.title || t("Campaign")}</span></h1>
        <div dangerouslySetInnerHTML={{__html: data.content}} />
      </div>
    );
  }
  return (
    <div className="textZone" style={{textAlign: "center", padding: "40px 20px"}}>
      <h1 className="mainTitle wLine cmsPage"><span>{t("Campaign")}</span></h1>
      <p>{t("Campaign page is not available yet.")}</p>
      <p><Link to="/" className="buton anim">{t("Home")}</Link></p>
    </div>
  );
}
